/* ND B2B — order popup */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("nd-b2b-popup");
    if (!popup) return;

    const content = popup.querySelector("[data-nd-b2b-content]");
    const success = popup.querySelector("[data-nd-b2b-success]");
    const error = popup.querySelector("[data-nd-b2b-error]");
    const form = popup.querySelector("#nd-b2b-form");
    const img = popup.querySelector("[data-nd-b2b-img]");
    const title = popup.querySelector("[data-nd-b2b-title]");
    const subtitle = popup.querySelector("[data-nd-b2b-subtitle]");
    const price = popup.querySelector("[data-nd-b2b-price]");
    const subject = popup.querySelector("[data-nd-b2b-subject]");
    const bodyField = popup.querySelector("[data-nd-b2b-body]");
    let lastTrigger = null;

    const hideError = () => {
      if (error) error.hidden = true;
    };

    const showError = () => {
      if (error) error.hidden = false;
    };

    const close = () => {
      popup.classList.remove("is-open");
      popup.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      hideError();
      if (lastTrigger && typeof lastTrigger.focus === "function") {
        lastTrigger.focus();
      }
    };

    const open = (btn) => {
      lastTrigger = btn;
      const name = btn.dataset.productName;
      const sub = btn.dataset.productSubtitle;
      const pr = btn.dataset.productPrice;
      const src = btn.dataset.productImage;

      if (img && src) img.src = src;
      if (title) title.textContent = name || "";
      if (subtitle) subtitle.textContent = sub || "";
      if (price) price.textContent = pr || "";
      if (subject) subject.value = "B2B Order: " + name + " — " + pr;

      if (content) content.style.display = "";
      if (success) success.classList.remove("is-visible");
      if (form) form.reset();
      hideError();

      popup.classList.add("is-open");
      popup.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      const closeBtn = popup.querySelector(".nd-b2b-popup-close");
      if (closeBtn) closeBtn.focus();
    };

    document.querySelectorAll("[data-open-b2b-popup]").forEach((btn) => {
      btn.addEventListener("click", () => open(btn));
    });

    popup.querySelectorAll("[data-close-b2b-popup]").forEach((el) => {
      el.addEventListener("click", close);
    });

    popup.addEventListener("click", (e) => {
      if (e.target === popup) close();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && popup.classList.contains("is-open")) close();
    });

    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        hideError();

        const data = new FormData(form);
        const packName = title ? title.textContent.trim() : "";
        const packSub = subtitle ? subtitle.textContent.trim() : "";
        const packPrice = price ? price.textContent.trim() : "";
        const variant = data.get("contact[variant]") || "";
        const firstName = data.get("contact[first_name]") || "";
        const lastName = data.get("contact[last_name]") || "";
        const company = data.get("contact[company]") || "";
        const cvr = data.get("contact[cvr]") || "";
        const phone = data.get("contact[phone]") || "";
        const email = data.get("contact[email]") || "";

        const summary = [
          "B2B Office Pack Order",
          "",
          "Pack: " + packName,
          "Size: " + packSub,
          "Price: " + packPrice,
          "Flavour: " + variant,
          "",
          "Name: " + firstName + " " + lastName,
          "Company: " + company,
          "CVR: " + (cvr || "—"),
          "Phone: " + phone,
          "Email: " + email,
        ].join("\n");

        if (subject) {
          subject.value = "B2B Order: " + packName + " (" + variant + ") — " + packPrice;
        }
        if (bodyField) {
          bodyField.value = summary;
        } else {
          data.set("contact[body]", summary);
        }

        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch("/contact#contact_form", {
          method: "POST",
          body: data,
          headers: { Accept: "application/json" },
        })
          .then((response) => {
            if (!response.ok) throw new Error("submit failed");
            if (content) content.style.display = "none";
            if (success) success.classList.add("is-visible");
          })
          .catch(() => {
            showError();
          })
          .finally(() => {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }
  });
})();
